import { normalizeCertificates } from './normalizeCertificates'

export const buildTrainingPayload = (form, placowka) => {
	const certificates = normalizeCertificates(form.certificates)

	return {
		nazwa: form.nazwa?.trim() || '',
		placowkaId: placowka?._id || placowka?.id || '',
		placowkaName: placowka?.nazwa || '',
		certificates,
		data_rozpoczecia: form.data_rozpoczecia || '',
		data_zakonczenia: form.data_zakonczenia || form.data_rozpoczecia || '',
		// API uses separate "godzina_*" and "uwagi" field names.
		godzina_rozpoczecia: form.startTime || '',
		godzina_zakonczenia: form.endTime || '',
		adres: form.ulica?.trim() || '',
		miasto: form.miasto?.trim() || '',
		kod_pocztowy: form.kod_pocztowy?.trim() || '',
		g_placeid: form.g_placeid || '',
		g_lat: form.g_lat === '' || form.g_lat == null ? '' : form.g_lat,
		g_long: form.g_long === '' || form.g_long == null ? '' : form.g_long,
		status: form.status || 'new',
		content: (Array.isArray(form.content) ? form.content : [])
			.map(item => `${item || ''}`.trim())
			.filter(Boolean),
		uwagi: form.remarks?.trim() || '',
	}
}
